// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item-divider {
  --padding-start: 0px;
  --inner-padding-end: 0px;
}
ion-item-divider ion-segment ion-label div:first-child {
  white-space: normal;
}

#add-contacts {
  font-weight: 700;
  text-transform: capitalize;
  font-size: 17px;
}

ion-item ion-label h4 {
  font-size: 17px;
  font-weight: 500;
}
ion-item ion-label p.contact-phone {
  font-size: 16px;
  font-weight: 500;
}
ion-item ion-label p.contact-type {
  font-size: 14px;
  font-weight: 500;
}
ion-item ion-icon {
  border: 1px solid var(--ion-color-primary, black);
  font-size: 24px;
  padding: 6px;
  border-radius: 50%;
}
ion-item ion-icon:last-child {
  margin-right: 16px;
}

#contactList {
  margin-bottom: 125px;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/contacts-core/lib/components/contact-single-picker-modal/contact-single-picker.modal.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,wBAAA;AACF;AAAE;EACE,mBAAA;AAEJ;;AAEA;EACE,gBAAA;EACA,0BAAA;EACA,eAAA;AACF;;AAII;EACE,eAAA;EACA,gBAAA;AADN;AAGI;EACE,eAAA;EACA,gBAAA;AADN;AAGI;EACE,eAAA;EACA,gBAAA;AADN;AAIE;EACE,iDAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAFJ;AAGI;EACE,kBAAA;AADN;;AAMA;EACE,oBAAA;AAHF","sourcesContent":["ion-item-divider {\n  --padding-start: 0px;\n  --inner-padding-end: 0px;\n  ion-segment ion-label div:first-child {\n    white-space: normal;\n  }\n}\n\n#add-contacts {\n  font-weight: 700;\n  text-transform: capitalize;\n  font-size: 17px;\n}\n\nion-item {\n  ion-label {\n    h4 {\n      font-size: 17px;\n      font-weight: 500;\n    }\n    p.contact-phone {\n      font-size: 16px;\n      font-weight: 500;\n    }\n    p.contact-type {\n      font-size: 14px;\n      font-weight: 500;\n    }\n  }\n  ion-icon {\n    border: 1px solid var(--ion-color-primary, black);\n    font-size: 24px;\n    padding: 6px;\n    border-radius: 50%;\n    &:last-child {\n      margin-right: 16px;\n    }\n  }\n}\n\n#contactList{\n  margin-bottom: 125px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
